// extracted by mini-css-extract-plugin
export default {"vacancyCreateWrapper":"singleApplicationForm_vacancyCreateWrapper__Nb3yu"};